<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <lock-card>
        <img slot="imageProfile" v-if="user.avatar" :src="user.avatar" alt="avatar" />
        <img slot="imageProfile" v-else :src="require('/public/img/faces/avatar.jpg')" alt="">
        <h4 slot="title" class="title">{{ user.name }}</h4>
        <md-field slot="content">
          <label>请输入密码</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <md-button href class="md-success md-round" @click="userUnlock" slot="footer"
          >确 定</md-button
        >
      </lock-card>
    </div>
  </div>
</template>
<script>
import kit from '../../../../common/js/kit.js';
import { LockCard } from "@/components";
import { mapState } from 'vuex';
import { userUnlock,userLock } from '@/api/user';
export default {
    components: {
        LockCard,
    },
    data() {
        return {
            password: null,
            image: "/public/img/faces/avatar.jpg",
        };
    },
    computed: {
      ...mapState([
          'global'
      ]),
      user () {
        return this.global.user;
      }
    },
    created () {
        this.userLock();
        this.getUserInfo();
    },
    methods: {
        getUserInfo () { 
            this.user = kit.getUserInfo();
            if (!this.user.is_set_password) {
                this.$router.push({name: 'User'});
                this.$message.warning('锁屏需设置密码');
            }
        },
        userLock () {
            let that =this;
            userLock().then((res) => {
            }).catch(() => {
                this.$router.push({name: 'User'});
            });
        },
        userUnlock () {
            let that =this;
            let tempData ={
                password: that.password
            }
            userUnlock(tempData).then((res) => {
                if (res.code === '200') {
                    that.$router.push({name: 'Home'});
                }
            })
        }
    },
};
</script>
<style></style>
